import React from "react";

export const ThemeContext = React.createContext({
  layout: 'horizontal',
  themeName: 'legacy',
  setLayout: (newLayout: string) => {},
  setThemeName: (newThemeName: string) => {},
});